import Vue from 'vue'
import Vuex from 'vuex'

import dayConfiguratorModule from './day-configurator'

Vue.use(Vuex)

const store = new Vuex.Store({
    modules: {
        dayConfigurator: dayConfiguratorModule,
    },
    strict: process.env.NODE_ENV !== 'production'
})

export default store